import wa from '../assets/images/wa.png';
// import wa from '../assets/images/wa.jpg';
import { WHATSAPP_NUMBER } from '../constant/constant';

// FloatingWhatsAppButton.jsx
export default function WhatsAppIcon() {

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 p-4 rounded-full hover:scale-110 transition transform duration-200"
    >
      <img
        src={wa}
        alt="WhatsApp"
        className="w-12 h-12 md:w-full md:h-12 rounded"
      />
    </a>
  );
}

